export default __webpack_public_path__ + "static/media/pvilla6-3.2ab952f5.jpg";